/**
 * The one-line orientation a candidate EMAIL template needs: how to write a link, bold, and
 * bullets. The capability has always been there — bodies are stored as Markdown-ish text and
 * rendered to HTML on send (lib/mdEmail.js), so `[text](url)` becomes a real hyperlink — but
 * nothing in the editor said so, so recruiters could not find it ("I don't see a hyperlink
 * feature"). Since Oct 8 2026 links are made with the Link button and shown blue in the editor
 * (LinkTemplateEditor); the stored text is unchanged. The Slack sibling (SlackFormattingHint) covers the internal templates instead.
 */
export function EmailFormattingHint() {
  return (
    <p className="text-[11px] text-gray-400">
      Links: select words in the text and press 🔗 Link — they turn blue and become a clickable link
      in the email. Click into a blue link and press 🔗 Link again to change or remove it. Also{' '}
      <code className="font-mono">**bold**</code>, and lines starting with{' '}
      <code className="font-mono">-</code> become bullet points.
    </p>
  );
}
